import styled from 'styled-components'

import Modal from 'react-modal'

import { FaWindowClose } from "react-icons/fa"

export const Container = styled.div`
width: 100%;
height: 100vh;
background-color: ${({ theme }) => theme.colors.background};
padding: 0;
margin: 0; 
`;

export const ContentContainer = styled.div`
  width: 100%;  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.colors.background};
  padding-top: 16px;   
`

export const ContentSelectContainer = styled.div`
  width: 100%;  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.colors.background};
  padding-top: 16px; 
  
  @media (min-width: 768px) {   
    padding-left: 30%;
    padding-right: 30%;
  }
`

// `isFallback` = negocio sem imagem (url nula ou quebrada). Nesse caso
// mostra a logo do app sobre fundo bege, com `contain` + padding para a
// logo (1.51:1) caber inteira no container quase quadrado, sem cortar.
export const Logo = styled.div`
  width: 50vw;
  height: 45vw; 
  background-color: ${({ theme }) => theme.colors.background};
  background-image: url(${({ url }) => url});
  background-size: ${({ isFallback }) => isFallback ? 'contain' : 'cover'};
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: content-box;  
  padding: ${({ isFallback }) => isFallback ? '16px' : '0'};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 14px;
  margin-bottom: 32px;

  @media (min-width: 768px) {
    width: 10vw;
    height: 10vw;
  }
  `

export const HoursListContainer = styled.div`
  width: 90%;    
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;    
`

// Chip de horario: superficie ESCURA sobre o bege, como o card. Horario e
// "valor em destaque" (DESIGN.md > Tipografia), por isso peso 500.
export const HourContainer = styled.button`
  width: 75px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.surfaceText}; 
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 10px;
  transition: border-color 0.2s, background-color 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accentOnSurface};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.surfaceAlt};
    border-color: ${({ theme }) => theme.colors.accentOnSurface};
  }
`

// MODAL
// DESIGN.md > Componentes: conteudo em `background` (bege), titulo em
// `textPrimary`, botao de fechar discreto (~20px em `textSecondary`).

export const WrapModal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContainer = styled(Modal)`  
width: 80%;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
outline: none;

  @media (min-width: 768px) {   
    width: 50%;
  }

   @media (min-width: 1024px) {   
    width: 40%;
  }

   @media (min-width: 1440px) {   
    width: 25%;
  }

`;

export const ModalContent = styled.div`   
  background-color: ${({ theme }) => theme.colors.background};   
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;    
  padding-bottom: 16px;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
`;

export const CloseButton = styled.button`
  width: 100%;
  border: none;
  display: flex;
  justify-content: start;
  background-color: ${({ theme }) => theme.colors.background};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`

export const CloseIcon = styled(FaWindowClose).attrs(({ theme }) => ({
  color: theme.colors.textSecondary,
  size: 32,
}))`
  margin: 16px;   
`;

export const ModalTitle = styled.p`
  text-align: center;
  margin: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
`
// RADIO BUTTON

export const RadioButtonContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const RadioButton = styled.input`
  margin: 8px;
  accent-color: ${({ theme }) => theme.colors.accent};
`
export const RadioButtonText = styled.p`
  margin-bottom: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
`
